import React, { useState, useEffect, useRef,Component  } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, Upload,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    LoadingOutlined
} from '@ant-design/icons';

import './styles.scss'



import moment from 'moment'
import {getData,editItem,addItem,deleteItem,getOptions,UploadPicture} from '../../../Redux/actions/crudActions'
import {errorParser} from '../../../utils/helpers'
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

// console.log(ClassicEditor.builtinPlugins.map( plugin => plugin.pluginName ));

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const Index = ({value,onChange}) => { 
    
    const dispatch = useDispatch()    
    const siteEditorRef = useRef(null);
    const { } = useSelector(
      state => ({
      
      }),
      shallowEqual
    )


    const [currentValue, setCurrentvalue] = useState(null)

    useEffect(() => {
      console.log('changeval',value)
      if(value){
        if(value.name){  
          preview(value)
        }else{
          setCurrentvalue(value)
        }
      }
  
    }, [value])

    const preview = async (val) =>{
      var src =  await getBase64(val);
      setCurrentvalue(src)
    }
    
    const uploadButton = () =>{
      return (
        <div className={"picuploadbox"}>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Upload</div>
        </div>
      )  
    }

    


    return ( 
  
      <Upload
        name="avatar"
        listType="picture"

        showUploadList={false}

        // beforeU(pload={beforeUpload}
        onChange={(e)=>{onChange(e.file.originFileObj)}}
      >
        {currentValue ? <img src={currentValue} alt="image"   className={"pictureinput"}/> : uploadButton()}
      </Upload>
  
    
 
     )
}
  
export default Index
  